import React from "react";
import "../arrow/style.scss";
import { BsArrowRightShort } from "react-icons/bs";

const Arrow = () => {
  return (
    <span className="arrow-icon">
      <BsArrowRightShort />
    </span>
  );
};

export default Arrow;
